const getGlobalStyles = () => ({
  "*, *::before, *::after": {
    boxSizing: "border-box",
  },

  html: {
    height: "100%",
    width: "100%",
  },

  body: {
    fontFamily: "Montserrat, sans-serif",
    height: "100%",
    width: "100%",
    margin: "0%",
    backgroundColor: "#f1f5f9",
    overflowX: "hidden",
  },

  "#root": {
    minHeight: "100%",
    width: "100%",
  },

  ":root": {
    "--color-hex": "#1E1E1E",
  },

  ".appLayout": {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    minHeight: "100dvh",
    width: "100%",
    overflow: "hidden",
  },

  ".appLayoutContent": {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
  },
});

export default getGlobalStyles;
